import React, { useState } from 'react';
import Modal from 'react-modal';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faCalendarAlt, faBuilding } from '@fortawesome/free-solid-svg-icons';

import axios from 'axios';
import LoadingScreen from '../../../LoadingScreen';


import SimpleModal from './SimpleModal';

const customModalStyles = {
  content: {
    width: '80%', 
    height: '60%',
    maxWidth: '600px',
    margin: 'auto',
    display: 'flex',
    flexDirection: 'column',
    //justifyContent: 'center', // Center vertically
    alignItems: 'center', // Center horizontally
    borderRadius: '1%',
  },
};

const AddProgramModal = ({ isOpen, onRequestClose, onAddProgram, programTypes, institutions }) => {
  
  const [name, setName] = useState('');
  const [programType, setProgramType] = useState('');
  //const [institution, setInstitution] = useState('');

  //const [selectedFile, setSelectedFile] = useState({});

  const [registrationStatus, setRegistrationStatus] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [registrationError, setRegistrationErrorMessage] = useState('');
  const [isSimpleModalOpen, setIsSimpleModalOpen] = useState(false);

  

  const [isNetworkLoading, setIsNetworkLoading] = useState(false);


  const handleDropdownChange = (event) => {
    const selectedValue = event.target.value;

    //alert(selectedValue);

    setProgramType(selectedValue);
  };


  const closeSimpleModal = () => {
    setIsSimpleModalOpen(false);
    clearFields();
    if (registrationStatus == "Registration Successful") {
      //navigate("/");
      onRequestClose();
    }
    
  };
  const clearFields = () => {
    //
    setName('');
    setProgramType('');


    setRegistrationStatus(null);
    setIsModalOpen(false);
    setRegistrationErrorMessage('');
          //
  }

  const hitAddProgramEndpoint = async () => {
    const token = localStorage.getItem('token')
    //onAddInstitution(institutionName);
    //setInstitutionName('');

    setRegistrationErrorMessage('');
    setIsNetworkLoading(true);


    // alert(
    //   'name: ' + name +
    //   'programType: ' + programType 
    // );


    // if (
    //   //institutionName  == ''  ||
    //   //onboardingYear == '' ||
    //   //email == '' ||
    //   //genType == ''
    //   ) {
    //   alert("Please select a type.");
    //   setIsNetworkLoading(false);
    //   return;
    // }

    try {
      const formData = new FormData();
      //formData.append('name', "institutionName");
      formData.append('name', name);
      formData.append('programType', programType);
      //formData.append('programType', programType);

      // Append the actual file to the formData
      //formData.append('paymentEvidence', selectedFile);

      const response = await axios.post("https://gacsstage.zaptrance.ng/api/admin/programs", formData, {
        headers: {
          //'Content-Type': 'multipart/form-data', // Use multipart/form-data for file uploads
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      setIsNetworkLoading(false);

      if (response.data.success) {
        // Registration was successful, you can handle the response here
        //alert("ok");
        setRegistrationStatus("Registration Successful");
        // setIsModalOpen(true);
        setIsSimpleModalOpen(true);

        // console.log('Registration successful:' + response.data.message);
        // // You can also redirect the user to a confirmation page or do any other actions.

        // clearFields();

        // // Close the modal
        //onAddProgram();

      } else {
        // Handle the case where registration was not successful
        //alert("not ok");
        setRegistrationStatus("Registration Failed");
        setIsModalOpen(true);
        //console.error('Registration failed:' + response.data);
      }
    } catch (error) {
      setIsNetworkLoading(false);
      setRegistrationStatus("Registration Failed");
      //console.error('Registration Failed:'+ error);
      // Handle request error, e.g., display an error message to the user
  
  //    console.error('Registration Failed:'+ error.message);

  if (error.response && error.response.data && error.response.data.data) {
    const dataKeys = Object.keys(error.response.data.data);

    if (dataKeys.length > 0) {
      // Construct an error message from the data keys
      const errorMessage = dataKeys
        .map(key => {
          const messages = error.response.data.data[key];
          //return `${key}: ${messages.join(', ')}`;
          return `${messages.join(', ')}`;
        })
        .join('\n');

      setRegistrationErrorMessage(errorMessage);
    } else {
      // If there are no data keys, set a generic error message
      setRegistrationErrorMessage('An error occurred during registration.');
    }
  } else {
    // Handle other error cases if needed
    setRegistrationErrorMessage('An error occurred during registration.');
  }

  setIsModalOpen(true);
    }
  };

  

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      contentLabel="Add Institution Modal"
      style={customModalStyles}
    >
      <div className="flex justify-between items-center w-full px-8 pt-4">
  <div className="flex items-center">
    <FontAwesomeIcon icon={faBuilding} color="black" className='mr-6' size="2x"/>
    <h2 className='text-xl'>Add New Programs</h2>
  </div>



  <div>
    <button 
    onClick={() => {
      onRequestClose();
      clearFields();
      setRegistrationErrorMessage('');
    }}
      
      className="border p-2"
      style={{
        background: 'none',
        cursor: 'pointer',
        borderRadius: '50%',
        borderColor: 'black',
        display: 'inline-block',
        width: '30px',
        height: '30px',
        padding: '0',
      }}
    >
      <span aria-hidden="true">
        <FontAwesomeIcon icon={faTimes} color="black" />
      </span>
    </button>
  </div>
</div>


      <div className="w-full px-8 pt-4">

      

      <div className="flex flex-col py-2">
        <label>Program Type:</label>
        <select
          className="mt-2 p-2 focus"
          onChange={(e) => handleDropdownChange(e)}
        >
          <option value="Select">Select</option>
          {programTypes.map((type, index) => (
  <option key={index} value={type.id}>
    {type.name}
  </option>
))}
        </select>
      </div>

      <div className="flex flex-col py-2">
          <label>Name</label>
          <input
            style={{ backgroundColor: '#EDF2F6', width: '100%' }}
            className="rounded-lg mt-2 p-2 focus"
            type="text"
            placeholder="Please enter prgram name"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </div>

        


        <div className='text-center' style={{ display: 'flex', justifyContent: 'center' }}>
        <p className='text-center mb-4 text-red-500'
        style={{ 
          //color: 'red',//'#990000', 
          fontSize: '12px' }}>{registrationError}</p>
      </div>





        <div className="text-center pt-2">
            <button className="px-6 py-3 m-4" 
            style={{
            width: '200px',
            backgroundColor: '#095918',
            borderRadius: '30px',
            padding: '10px 20px',
            color: 'white',
            border: 'none',
          }}
            onClick={hitAddProgramEndpoint}
            >
              {isNetworkLoading ? (
                      <LoadingScreen />
                    ) : (
                      'Save'
                    )}
              </button>
            </div>


      </div>

      <SimpleModal 
isOpen={isSimpleModalOpen}
onRequestClose={closeSimpleModal}
registrationStatus={registrationStatus}
              registrationError={registrationError}
              message='Program'
/>

    </Modal>
  );
};

export default AddProgramModal;
